<template>
    <modal id="create-project-forms-modal" size="xl">
        <template slot="title">Add Building Forms</template>
        <template slot="body">
            <form-selector v-model="form.forms" :forms="forms"></form-selector>
        </template>
        <template slot="footer">
            <button class="btn btn-default" type="button" @click="closeModal('create-project-forms-modal')">Close</button>
            <button class="btn btn-success" type="button" @click="save()">Save</button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            project:{
                type: Object,
                required: true,
            },
            forms:{
                type: Array,
                required: true,
            }
        },

        data(){
            return {
                form: new Form({
                    forms: [],
                }, false)
            }
        },

        created(){
            this.form.forms = _.map(this.project.forms, form => {
                return form.id;
            });
        },

        methods: {

            save() {
                if (this.validate()) {
                    this.form.patch(`/projects/${this.project.slug}/forms`)
                        .then(response => {
                            Alert.withAction(`Project Forms Updated!`).then(() => {
                                this.refreshPage();
                            })
                        })
                        .catch(error => {
                            Alert.error(error.first());
                        })
                }
            },

            validate() {

                // Only admins can add all test's.
                if(this.authorize('admin')){
                    return true;
                }

                // 2016 Default
                var nrca_lti_04_A = [10, 11];

                if(this.project.version == 2019){
                    nrca_lti_04_A = [23, 24];
                }

                if(this.project.version == 2022){
                    nrca_lti_04_A = [35, 36, 37, 38];
                }

                let intersection = this.form.forms.filter(x => nrca_lti_04_A.includes(x));

                if (intersection.length > 1) {
                    Alert.error('You only can select one of the NRCA-LTI-04-A forms')
                    return false;
                }

                // Only validate NRCA-LTI-05 FOR 2016 Projects.
                if (this.project.version == 2016) {

                    var nrca_lti_05_A = [12, 13];

                    if (this.form.forms.includes(nrca_lti_05_A[0]) && this.form.forms.includes(nrca_lti_05_A[1])) {
                        Alert.error('You only can select one of the NRCA-LTI-05-A forms')
                        return false;
                    }
                }

                return true;
            }
        },
    }
</script>
